import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext.jsx";

const LoginPage = () => {
  const { login } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const success = await login(username, password);
    if (success) {
      navigate("/dashboard", { replace: true });
    } else {
      setError("Invalid username or password. (Hint: admin/password)");
    }
  };

  return (
    <div className="p-8 bg-white rounded-lg shadow-xl max-w-md mx-auto my-10">
      <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
        Login to Admin Portal
      </h2>
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label
            htmlFor="username"
            className="block text-gray-700 text-sm font-semibold mb-2"
          >
            Username:
          </label>
          <input
            type="text"
            id="username"
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label
            htmlFor="password"
            className="block text-gray-700 text-sm font-semibold mb-2"
          >
            Password:
          </label>
          <input
            type="password"
            id="password"
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <p className="text-red-600 text-sm text-center">{error}</p>}
        <button
          type="submit"
          className="w-full bg-purple-700 text-white py-3 px-6 rounded-md hover:bg-purple-800 transition-colors duration-300 font-semibold text-lg shadow-md"
        >
          Login
        </button>
      </form>
      <p className="text-center text-gray-600 text-sm mt-6">
        This login is for demonstration. In a real application, this would
        connect to your FastAPI backend.
      </p>
    </div>
  );
};

export default LoginPage;
